module.exports = __webpack_public_path__ + "img/new-person.4e9b4ae0.svg";